import React from 'react';

import { ApButtonIcon } from '@alixpartners/ui-components';
import { SettingsContext } from 'contexts/SettingsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import OtherFilters from './OtherFilters';
import PeriodSelect from './PeriodSelect';
import { TaxonomySelect } from './TaxonomySelect';
import { convertToArray } from 'Details/utils';
import { Wrapper, Divider, FiltersWrapper } from './SecondaryNav.styles';
import { isUndefined } from 'lodash';

export const FilterPanel = ({
	companiesList,
	setQueryStringStateAndPush,
	customFiltersValues,
	storedQueryId,
	spendType,
}) => {
	const predefinedFilters = [
		{
			name: 'purchasingLegalEntity',
			label: 'Purchasing Legal Entity',
			values: companiesList,
			order: 1,
		},
	];

	const clearAllFilters = () => {
		setQueryStringStateAndPush({
			customFilters: [],
			customFiltersValues: [],
			storedQueryId: null,
		});
	};
	const isClearVisible =
		(customFiltersValues && customFiltersValues.length > 0) || !!storedQueryId;

	return (
		<Wrapper>
			<FiltersWrapper>
				<PeriodSelect order={2} />
				<OtherFilters order={3} predefinedFilters={predefinedFilters} />
			</FiltersWrapper>
			{isClearVisible && (
				<ApButtonIcon iconName="close" onClick={clearAllFilters} />
			)}
			<Divider />
			{!isUndefined(spendType) && <TaxonomySelect />}
		</Wrapper>
	);
};

export default props => (
	<SettingsContext.Consumer>
		{({ companiesList }) => (
			<QueryStringContext.Consumer>
				{({
					setQueryStringStateAndPush,
					customFiltersValues,
					storedQueryId,
					spendType,
				}) => (
					<FilterPanel
						{...props}
						companiesList={companiesList}
						setQueryStringStateAndPush={setQueryStringStateAndPush}
						customFiltersValues={convertToArray(customFiltersValues)}
						storedQueryId={storedQueryId}
						spendType={spendType}
					/>
				)}
			</QueryStringContext.Consumer>
		)}
	</SettingsContext.Consumer>
);
